import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import RFField from "../../../Form/RFField";
import RFForm from "../../../Form/RFForm";
import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";

const ToolbarVideo = () => {
  const { editor } = useEditorContext();

  const [modal, setModal] = useState(false);
  const [link, setLink] = useState("");

  const toggle = () => {
    setModal(!modal);
    setLink("");
  };

  const handleSubmit = () => {
    editor
      .chain()
      .focus()
      .setYoutubeVideo({
        src: link,
        width: 480,
        height: 320,
      })
      .run();

    toggle();
  };

  return (
    <>
      <ToolbarItem
        id={`video-toolbar-item`}
        tooltip={`Videó beszúrása`}
        active={false}
        onToggle={toggle}
        icon={<i className="fa fa-video" aria-hidden="true" />}
      />

      <Modal isOpen={modal} toggle={toggle} backdrop="static">
        <RFForm onSubmit={handleSubmit}>
          <ModalHeader toggle={toggle}>Videó beszúrása</ModalHeader>
          <ModalBody>
            <RFField
              id="link"
              name="link"
              type="text"
              label="YouTube videó linkje"
              value={link}
              onChange={(e, v) => setLink(v)}
              required
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary">OK</Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Mégsem
            </Button>
          </ModalFooter>
        </RFForm>
      </Modal>
    </>
  );
};

export default ToolbarVideo;
